<template>
  <div>
    <b-tabs>
      <b-tab title="Due" active lazy>
        <po-due-tab @onReceiveItem="onReceiveItem" />
      </b-tab>
      <b-tab title="Past Due" lazy :active="routerHash == '#pastDue'">
        <po-past-due-tab @onReceiveItem="onReceiveItem" />
      </b-tab>
      <b-tab title="Not Scheduled" lazy>
        <po-not-scheduled-tab @onReceiveItem="onReceiveItem" />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import PoDueTab from './tabs/DueTab';
import PoPastDueTab from './tabs/PastDueTab';
import PoNotScheduledTab from './tabs/NotScheduledTab';
import { filter } from 'minimatch';

export default {
  components: {
    PoDueTab,
    PoPastDueTab,
    PoNotScheduledTab
  },
  computed: {
    routerHash() {
      return this.$route.hash;
    },  
  },  
  methods: {
    onReceiveItem($event) {
      let routeData = this.$router.resolve({
          name: 'shipping.receiveitemdetails',
          params: { purchaseOrderId: $event.purchaseOrderId,
                purchaseOrderLineId: $event.purchaseOrderLineId, },
        });
        window.open(routeData.href, '_blank');
    },
  }
};
</script>

<style scoped>
.sched-division {
    padding: 0.5rem;
    margin-top: 2rem;
}
</style>